@let addressValue = address();
@let portfolioIdValue = portfolioId();
@if (addressValue) {
  @let buildingIdValue = buildingId();
  @if (buildingIdValue) {
    <cfp-building-tags [buildingId]="buildingIdValue" />
  }
  <div class="row">
    <div class="col-12 col-md-auto building-header-address" [class.has-search-value]="hasSearchValue()">
      <cfp-building-address
        [buildingId]="buildingIdValue"
        [address]="addressValue"
        [name]="name()"
        [countryCode]="countryCode()"
        [showBuildingName]="showBuildingName"
        [combineNameAndAddress]="combineNameAndAddress()"
        [showMonumentIcon]="showMonumentIcon()"
        [customBuildingImageUrl]="customBuildingImageUrl()"
        data-test="buildingHeaderAddress"
        [useH1]="useH1()"
      >
        @if (!hideSelect()) {
          <cfp-select-building-combobox
            class="d-none d-lg-block"
            [portfolioId]="portfolioIdValue"
            [buildingId]="buildingIdValue"
            [showBuildingName]="showBuildingName"
            [combineNameAndAddress]="combineNameAndAddress()"
            (selected)="addressSelected($event)"
            #selectBuilding
          />
        }
      </cfp-building-address>
      <ng-content select="[building-address-under]" />
      @if (!hideDropdown()) {
        <cfp-dropdown
          [icon]="'ellipsis-v'"
          class="cfp-dropdown-options d-print-none"
          [ariaLabel]="'actions' | cfpTranslate"
          [disabled]="loading"
          [enableDropup]="true"
          [formControlSize]="'small'"
          [dataTest]="'buildingActions'"
        >
          <cfp-building-address
            class="d-flex d-sm-none"
            [buildingId]="buildingIdValue"
            [address]="addressValue"
            [showBuildingName]="showBuildingName"
            [combineNameAndAddress]="combineNameAndAddress()"
          />
          <ng-content select="[dropdown-options-top]" />

          @defer (on viewport) {
            @if (portfolioIdValue && !hideGoToAllBuildings()) {
              <a [routerLink]="backPath" class="dropdown-item">
                <cfp-icon [icon]="'city'" />
                <span>{{ 'building.back' | cfpTranslate }}</span>
                <cfp-icon [icon]="'chevron-right'" />
              </a>
              <div class="dropdown-divider"></div>
            }
            @if (showBuildingCode) {
              <button class="dropdown-item" (click)="changeBuildingCode()">
                <cfp-icon [icon]="'file-alt'" />
                <span>{{ 'buildingCode' | cfpTranslate }}</span>
                @let buildingCodeValue = buildingCode();
                @if (buildingCodeValue) {
                  <strong [attr.title]="buildingCodeValue">{{ buildingCodeValue }}</strong>
                }
                <cfp-icon [icon]="'chevron-right'" />
              </button>
            }
            <button class="dropdown-item" (click)="copyBuildingAddress()">
              <cfp-icon [icon]="copied ? 'check-circle' : 'copy'" [iconStyle]="copied ? 'success' : 'default'" />
              <span>{{ 'copyAddress' | cfpTranslate }}</span>
            </button>
            @if (canDownloadReport()) {
              <button class="dropdown-item" (click)="downloadReport()">
                <cfp-icon [icon]="'file-pdf'" />
                <span>{{ 'downloadReport' | cfpTranslate }}</span>
              </button>
            }
            @if (hasAuditTrailLicense() && !hideAuditTrail()) {
              <button (click)="showAuditTrail()" class="dropdown-item">
                <cfp-icon [icon]="'file-alt'" />
                <span>{{ 'building.auditTrail.button' | cfpTranslate }}</span>
              </button>
            }
            @defer (when hasEnergyLabelRequirementLicense()) {
              <cfp-energy-label-requirement-change-option [buildingId]="buildingIdValue" />
            }
            @defer (when canModifyBuildingProperties()) {
              <cfp-notes-option [buildingId]="buildingIdValue" />
            }
            @if (buildingIdValue) {
              @defer (when canModifyBuildingProperties()) {
                <cfp-building-display-address-change-option
                  [buildingId]="buildingIdValue"
                  [displayAddress]="addressValue"
                />
              }
            }
            @if (canDeleteBuilding()) {
              <button (click)="deleteBuilding()" class="dropdown-item text-danger">
                <cfp-icon [icon]="'trash'" />
                <span>{{ 'building.remove.button' | cfpTranslate }}</span>
              </button>
            }
            @if (!hideManageBuildingTags()) {
              <button (click)="showTags()" class="dropdown-item" data-test="manageBuildingTags">
                <cfp-icon [icon]="'tag'" />
                <span>{{ 'tags.manage' | cfpTranslate }}</span>
              </button>
            }
          } @placeholder {
            <span class="dropdown-item">{{ 'loading' | cfpTranslate }}</span>
          }
        </cfp-dropdown>
      }
    </div>
    <div id="buildingHeader" [class]="buildingHeaderClass()">
      <ng-content select="[building-header]" />
    </div>
  </div>
  <ng-content select="[building-header-bottom]" />

  <cfp-page-section [section]="'BUILDING_HEADER_BOTTOM'" />
}
